import React from "react";
import Card from './Card';

class Cards extends React.Component {

    render() {

        return (
          <div className="rob-card__list">
              {this.props.cards.map(function (name, index) {
                 return  <Card key={index} {...name} />
              })
              }
              <div className="rob-card rob-card--placeholder"></div>
              <div className="rob-card rob-card--placeholder"></div>
          </div>
        )
    }
}

Cards.defaultProps = {cards: []};

export default Cards;




// WEBPACK FOOTER //
// ./src/components/elements/Cards.js